import { render, staticRenderFns } from "./Statistiques.vue?vue&type=template&id=2e019e3c&"
import script from "./Statistiques.vue?vue&type=script&lang=js&"
export * from "./Statistiques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports